
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

const OrderHistoryLoading = () => {
  return (
    <div className="relative space-y-8">
       <div className="absolute left-[11px] h-full w-0.5 bg-border/50" />
      {[...Array(3)].map((_, i) => (
        <div key={i} className="relative flex items-start">
          <div className="flex h-full w-6 items-center justify-center">
            <div className="absolute top-1 -left-[0.5px] z-10">
              <Skeleton className="h-6 w-6 rounded-full" />
            </div>
          </div>
          <div className="pl-8 flex-grow">
            <Card variant="glass" className="border-white/10">
              <CardHeader>
                <div className="flex justify-between items-center">
                  <Skeleton className="h-6 w-40" />
                  <Skeleton className="h-6 w-24" />
                </div>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="space-y-1">
                    <Skeleton className="h-4 w-16" />
                    <Skeleton className="h-5 w-24" />
                  </div>
                  <div className="space-y-1">
                    <Skeleton className="h-4 w-12" />
                    <Skeleton className="h-5 w-20" />
                  </div>
                  <div className="space-y-1">
                    <Skeleton className="h-4 w-10" />
                    <Skeleton className="h-5 w-16" />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderHistoryLoading;
